// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /league-catalog/get.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeLeagueCatalogGetBody,
  typeLeagueCatalogGetOutput200,
} from "../../sdk/leagueCatalog/postLeagueCatalogGet";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildLeagueCatalogGetQueryKey(
  payload: typeLeagueCatalogGetBody,
): string[] {
  const queryKeySegments: string[] = [];

  return [
    "post:leagueCatalog:leagueCatalogGet",
    "svc:sports-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeLeagueCatalogGetOutput200,
    unknown,
    typeLeagueCatalogGetOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useLeagueCatalogGet(
  payload: typeLeagueCatalogGetBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildLeagueCatalogGetQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postLeagueCatalogGet(payload),
    ...resolvedOptions,
  });
}
